function t(a) {
  var res = {};
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [ki, vi] = _step.value;
      res[ks[ki]] = colors[vi];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return res;
}
var colors = [
  "hsla(0, 0%, 10%, 1)",
  "hsla(0, 0%, 38%, 1)",
  "hsla(0, 0%, 100%, 0)",
  "hsla(0, 0%, 100%, 0.2)",
  "hsla(0, 0%, 100%, 0.4)",
  "hsla(0, 0%, 100%, 0.6)",
  "hsla(0, 0%, 100%, 0.8)",
  "hsla(0, 0%, 100%, 1)",
  "hsla(0, 0%, 95%, 1)",
  "hsla(0, 0%, 93%, 1)",
  "hsla(0, 0%, 91%, 1)",
  "hsla(0, 0%, 88%, 1)",
  "hsla(0, 0%, 85%, 1)",
  "hsla(0, 0%, 82%, 1)",
  "hsla(0, 0%, 76%, 1)",
  "hsla(0, 0%, 56%, 1)",
  "hsla(0, 0%, 50%, 1)",
  "hsla(0, 0%, 42%, 1)",
  "hsla(0, 0%, 9%, 1)",
  "hsla(0, 0%, 9%, 0)",
  "hsla(0, 0%, 9%, 0.2)",
  "hsla(0, 0%, 9%, 0.4)",
  "hsla(0, 0%, 9%, 0.6)",
  "hsla(0, 0%, 9%, 0.8)",
  "hsl(206, 100%, 99.2%)",
  "hsl(210, 100%, 98.0%)",
  "hsl(209, 100%, 96.5%)",
  "hsl(210, 98.8%, 94.0%)",
  "hsl(209, 95.0%, 90.1%)",
  "hsl(209, 81.2%, 84.5%)",
  "hsl(208, 77.5%, 76.9%)",
  "hsl(206, 81.9%, 65.3%)",
  "hsl(206, 100%, 50.0%)",
  "hsl(208, 100%, 47.3%)",
  "hsl(211, 100%, 43.2%)",
  "hsl(211, 100%, 15.0%)",
  "hsl(359, 100%, 99.4%)",
  "hsl(359, 100%, 98.6%)",
  "hsl(360, 100%, 96.8%)",
  "hsl(360, 97.9%, 94.8%)",
  "hsl(360, 90.2%, 91.9%)",
  "hsl(360, 81.7%, 87.8%)",
  "hsl(359, 74.2%, 81.7%)",
  "hsl(359, 69.5%, 74.3%)",
  "hsl(358, 75.0%, 59.0%)",
  "hsl(358, 69.4%, 55.2%)",
  "hsl(358, 65.0%, 48.7%)",
  "hsl(354, 50.0%, 14.6%)",
  "hsl(60, 54.0%, 98.5%)",
  "hsl(52, 100%, 95.5%)",
  "hsl(55, 100%, 90.9%)",
  "hsl(54, 100%, 86.6%)",
  "hsl(52, 97.9%, 82.0%)",
  "hsl(50, 89.4%, 76.1%)",
  "hsl(47, 80.4%, 68.0%)",
  "hsl(48, 100%, 46.1%)",
  "hsl(53, 92.0%, 50.0%)",
  "hsl(50, 100%, 48.5%)",
  "hsl(42, 100%, 29.0%)",
  "hsl(40, 55.0%, 13.5%)",
  "hsl(136, 50.0%, 98.9%)",
  "hsl(138, 62.5%, 96.9%)",
  "hsl(139, 55.2%, 94.5%)",
  "hsl(140, 48.7%, 91.0%)",
  "hsl(141, 43.7%, 86.0%)",
  "hsl(143, 40.3%, 79.0%)",
  "hsl(146, 38.5%, 69.0%)",
  "hsl(151, 40.2%, 54.1%)",
  "hsl(151, 55.0%, 41.5%)",
  "hsl(152, 57.5%, 37.6%)",
  "hsl(153, 67.0%, 28.5%)",
  "hsl(155, 40.0%, 14.0%)",
  "rgba(0,0,0,0.04)",
  "rgba(0,0,0,0.08)",
  "rgba(0,0,0,0.16)",
  "rgba(0,0,0,0.24)",
  "rgba(0,0,0,0.32)",
  "rgba(0,0,0,0.4)",
  "#050505",
  "#151515",
  "#191919",
  "#232323",
  "#282828",
  "#323232",
  "#424242",
  "#494949",
  "#545454",
  "#626262",
  "#a5a5a5",
  "#fff",
  "#f2f2f2",
  "hsl(0, 0%, 93%)",
  "hsl(0, 0%, 91%)",
  "hsl(0, 0%, 88%)",
  "hsl(0, 0%, 85%)",
  "hsl(0, 0%, 82%)",
  "hsl(0, 0%, 76%)",
  "hsl(0, 0%, 56%)",
  "hsl(0, 0%, 50%)",
  "hsl(0, 0%, 42%)",
  "hsl(0, 0%, 9%)",
  "hsla(0, 0%, 2%, 1)",
  "hsla(0, 0%, 8%, 1)",
  "hsla(0, 0%, 14%, 1)",
  "hsla(0, 0%, 16%, 1)",
  "hsla(0, 0%, 20%, 1)",
  "hsla(0, 0%, 26%, 1)",
  "hsla(0, 0%, 29%, 1)",
  "hsla(0, 0%, 33%, 1)",
  "hsla(0, 0%, 65%, 1)",
  "hsla(0, 0%, 2%, 0)",
  "hsla(0, 0%, 2%, 0.2)",
  "hsla(0, 0%, 2%, 0.4)",
  "hsla(0, 0%, 2%, 0.6)",
  "hsla(0, 0%, 2%, 0.8)",
  "hsl(212, 35.0%, 9.2%)",
  "hsl(216, 50.0%, 11.8%)",
  "hsl(214, 59.4%, 15.3%)",
  "hsl(214, 65.8%, 17.9%)",
  "hsl(213, 71.2%, 20.2%)",
  "hsl(212, 77.4%, 23.1%)",
  "hsl(211, 85.1%, 27.4%)",
  "hsl(211, 89.7%, 34.1%)",
  "hsl(209, 100%, 60.6%)",
  "hsl(210, 100%, 66.1%)",
  "hsl(206, 98.0%, 95.8%)",
  "hsl(353, 23.0%, 9.8%)",
  "hsl(357, 34.4%, 12.0%)",
  "hsl(356, 43.4%, 16.4%)",
  "hsl(356, 47.6%, 19.2%)",
  "hsl(356, 51.1%, 21.9%)",
  "hsl(356, 55.2%, 25.9%)",
  "hsl(357, 60.2%, 31.8%)",
  "hsl(358, 65.0%, 40.4%)",
  "hsl(358, 85.3%, 64.0%)",
  "hsl(358, 100%, 69.5%)",
  "hsl(351, 89.0%, 96.0%)",
  "hsl(45, 100%, 5.5%)",
  "hsl(46, 100%, 6.7%)",
  "hsl(45, 100%, 8.7%)",
  "hsl(45, 100%, 10.4%)",
  "hsl(47, 100%, 12.1%)",
  "hsl(49, 100%, 14.3%)",
  "hsl(49, 90.3%, 18.4%)",
  "hsl(50, 100%, 22.0%)",
  "hsl(54, 100%, 68.0%)",
  "hsl(48, 100%, 47.0%)",
  "hsl(53, 100%, 91.0%)",
  "hsl(146, 30.0%, 7.4%)",
  "hsl(155, 44.2%, 8.4%)",
  "hsl(155, 46.7%, 10.9%)",
  "hsl(154, 48.4%, 12.9%)",
  "hsl(154, 49.7%, 14.9%)",
  "hsl(154, 50.9%, 17.6%)",
  "hsl(153, 51.8%, 21.8%)",
  "hsl(151, 51.7%, 28.4%)",
  "hsl(151, 49.3%, 46.5%)",
  "hsl(151, 50.0%, 53.2%)",
  "hsl(137, 72.0%, 94.0%)",
  "rgba(0,0,0,0.2)",
  "rgba(0,0,0,0.3)",
  "rgba(0,0,0,0.5)",
  "rgba(0,0,0,0.6)",
  "rgba(0,0,0,0.7)",
  "hsla(216, 100%, 99%, 0)",
  "hsla(216, 100%, 99%, 0.2)",
  "hsla(216, 100%, 99%, 0.4)",
  "hsla(216, 100%, 99%, 0.6)",
  "hsla(216, 100%, 99%, 0.8)",
  "hsla(210, 100%, 99%, 1)",
  "hsla(210, 100%, 98%, 1)",
  "hsla(210, 100%, 96%, 1)",
  "hsla(210, 100%, 94%, 1)",
  "hsla(209, 96%, 90%, 1)",
  "hsla(209, 82%, 85%, 1)",
  "hsla(208, 78%, 77%, 1)",
  "hsla(206, 82%, 65%, 1)",
  "hsla(206, 100%, 50%, 1)",
  "hsla(208, 100%, 47%, 1)",
  "hsla(211, 100%, 43%, 1)",
  "hsla(211, 100%, 15%, 1)",
  "hsla(211, 100%, 15%, 0)",
  "hsla(211, 100%, 15%, 0.2)",
  "hsla(211, 100%, 15%, 0.4)",
  "hsla(211, 100%, 15%, 0.6)",
  "hsla(211, 100%, 15%, 0.8)",
  "hsla(0, 100%, 99%, 0)",
  "hsla(0, 100%, 99%, 0.2)",
  "hsla(0, 100%, 99%, 0.4)",
  "hsla(0, 100%, 99%, 0.6)",
  "hsla(0, 100%, 99%, 0.8)",
  "hsla(0, 100%, 99%, 1)",
  "hsla(0, 100%, 97%, 1)",
  "hsla(0, 100%, 95%, 1)",
  "hsla(0, 90%, 92%, 1)",
  "hsla(0, 81%, 88%, 1)",
  "hsla(359, 74%, 82%, 1)",
  "hsla(359, 69%, 74%, 1)",
  "hsla(358, 75%, 59%, 1)",
  "hsla(358, 69%, 55%, 1)",
  "hsla(358, 65%, 49%, 1)",
  "hsla(355, 49%, 15%, 1)",
  "hsla(355, 48%, 15%, 0)",
  "hsla(355, 48%, 15%, 0.2)",
  "hsla(355, 48%, 15%, 0.4)",
  "hsla(355, 48%, 15%, 0.6)",
  "hsla(355, 48%, 15%, 0.8)",
  "hsla(60, 45%, 98%, 0)",
  "hsla(60, 45%, 98%, 0.2)",
  "hsla(60, 45%, 98%, 0.4)",
  "hsla(60, 45%, 98%, 0.6)",
  "hsla(60, 45%, 98%, 0.8)",
  "hsla(60, 50%, 98%, 1)",
  "hsla(52, 100%, 95%, 1)",
  "hsla(55, 100%, 91%, 1)",
  "hsla(54, 100%, 87%, 1)",
  "hsla(52, 98%, 82%, 1)",
  "hsla(50, 90%, 76%, 1)",
  "hsla(47, 80%, 68%, 1)",
  "hsla(48, 100%, 46%, 1)",
  "hsla(53, 92%, 50%, 1)",
  "hsla(50, 100%, 48%, 1)",
  "hsla(42, 100%, 29%, 1)",
  "hsla(41, 56%, 13%, 1)",
  "hsla(41, 55%, 13%, 0)",
  "hsla(41, 55%, 13%, 0.2)",
  "hsla(41, 55%, 13%, 0.4)",
  "hsla(41, 55%, 13%, 0.6)",
  "hsla(41, 55%, 13%, 0.8)",
  "hsla(140, 60%, 99%, 0)",
  "hsla(140, 60%, 99%, 0.2)",
  "hsla(140, 60%, 99%, 0.4)",
  "hsla(140, 60%, 99%, 0.6)",
  "hsla(140, 60%, 99%, 0.8)",
  "hsla(140, 60%, 99%, 1)",
  "hsla(138, 63%, 97%, 1)",
  "hsla(139, 57%, 95%, 1)",
  "hsla(139, 48%, 91%, 1)",
  "hsla(141, 44%, 86%, 1)",
  "hsla(142, 40%, 79%, 1)",
  "hsla(146, 38%, 69%, 1)",
  "hsla(151, 40%, 54%, 1)",
  "hsla(151, 55%, 42%, 1)",
  "hsla(152, 57%, 38%, 1)",
  "hsla(153, 67%, 28%, 1)",
  "hsla(155, 41%, 14%, 1)",
  "hsla(155, 41%, 14%, 0)",
  "hsla(155, 41%, 14%, 0.2)",
  "hsla(155, 41%, 14%, 0.4)",
  "hsla(155, 41%, 14%, 0.6)",
  "hsla(155, 41%, 14%, 0.8)",
  "hsla(214, 35%, 9%, 0)",
  "hsla(214, 35%, 9%, 0.2)",
  "hsla(214, 35%, 9%, 0.4)",
  "hsla(214, 35%, 9%, 0.6)",
  "hsla(214, 35%, 9%, 0.8)",
  "hsla(212, 36%, 9%, 1)",
  "hsla(216, 50%, 12%, 1)",
  "hsla(214, 59%, 15%, 1)",
  "hsla(214, 65%, 18%, 1)",
  "hsla(213, 71%, 20%, 1)",
  "hsla(212, 78%, 23%, 1)",
  "hsla(211, 86%, 27%, 1)",
  "hsla(211, 90%, 34%, 1)",
  "hsla(209, 100%, 61%, 1)",
  "hsla(210, 100%, 66%, 1)",
  "hsla(206, 100%, 96%, 1)",
  "hsla(207, 100%, 96%, 0)",
  "hsla(207, 100%, 96%, 0.2)",
  "hsla(207, 100%, 96%, 0.4)",
  "hsla(207, 100%, 96%, 0.6)",
  "hsla(207, 100%, 96%, 0.8)",
  "hsla(351, 25%, 10%, 0)",
  "hsla(351, 25%, 10%, 0.2)",
  "hsla(351, 25%, 10%, 0.4)",
  "hsla(351, 25%, 10%, 0.6)",
  "hsla(351, 25%, 10%, 0.8)",
  "hsla(350, 24%, 10%, 1)",
  "hsla(357, 34%, 12%, 1)",
  "hsla(357, 43%, 16%, 1)",
  "hsla(356, 47%, 19%, 1)",
  "hsla(356, 51%, 22%, 1)",
  "hsla(357, 55%, 26%, 1)",
  "hsla(357, 60%, 32%, 1)",
  "hsla(358, 65%, 40%, 1)",
  "hsla(358, 86%, 64%, 1)",
  "hsla(358, 100%, 69%, 1)",
  "hsla(353, 90%, 96%, 1)",
  "hsla(353, 90%, 96%, 0)",
  "hsla(353, 90%, 96%, 0.2)",
  "hsla(353, 90%, 96%, 0.4)",
  "hsla(353, 90%, 96%, 0.6)",
  "hsla(353, 90%, 96%, 0.8)",
  "hsla(46, 100%, 5%, 0)",
  "hsla(46, 100%, 5%, 0.2)",
  "hsla(46, 100%, 5%, 0.4)",
  "hsla(46, 100%, 5%, 0.6)",
  "hsla(46, 100%, 5%, 0.8)",
  "hsla(45, 100%, 5%, 1)",
  "hsla(46, 100%, 7%, 1)",
  "hsla(45, 100%, 9%, 1)",
  "hsla(45, 100%, 10%, 1)",
  "hsla(46, 100%, 12%, 1)",
  "hsla(49, 100%, 14%, 1)",
  "hsla(49, 89%, 18%, 1)",
  "hsla(50, 100%, 22%, 1)",
  "hsla(54, 100%, 68%, 1)",
  "hsla(48, 100%, 47%, 1)",
  "hsla(53, 100%, 91%, 1)",
  "hsla(53, 100%, 91%, 0)",
  "hsla(53, 100%, 91%, 0.2)",
  "hsla(53, 100%, 91%, 0.4)",
  "hsla(53, 100%, 91%, 0.6)",
  "hsla(53, 100%, 91%, 0.8)",
  "hsla(145, 33%, 7%, 0)",
  "hsla(145, 33%, 7%, 0.2)",
  "hsla(145, 33%, 7%, 0.4)",
  "hsla(145, 33%, 7%, 0.6)",
  "hsla(145, 33%, 7%, 0.8)",
  "hsla(145, 32%, 7%, 1)",
  "hsla(155, 44%, 8%, 1)",
  "hsla(155, 46%, 11%, 1)",
  "hsla(154, 48%, 13%, 1)",
  "hsla(155, 50%, 15%, 1)",
  "hsla(154, 51%, 18%, 1)",
  "hsla(153, 51%, 22%, 1)",
  "hsla(151, 52%, 28%, 1)",
  "hsla(151, 49%, 46%, 1)",
  "hsla(151, 50%, 53%, 1)",
  "hsla(136, 73%, 94%, 1)",
  "hsla(134, 73%, 94%, 0)",
  "hsla(134, 73%, 94%, 0.2)",
  "hsla(134, 73%, 94%, 0.4)",
  "hsla(134, 73%, 94%, 0.6)",
  "hsla(134, 73%, 94%, 0.8)"
];
var ks = [
  "accentBackground",
  "accentColor",
  "background0",
  "background02",
  "background04",
  "background06",
  "background08",
  "color1",
  "color2",
  "color3",
  "color4",
  "color5",
  "color6",
  "color7",
  "color8",
  "color9",
  "color10",
  "color11",
  "color12",
  "color0",
  "color02",
  "color04",
  "color06",
  "color08",
  "background",
  "backgroundHover",
  "backgroundPress",
  "backgroundFocus",
  "borderColor",
  "borderColorHover",
  "borderColorPress",
  "borderColorFocus",
  "color",
  "colorHover",
  "colorPress",
  "colorFocus",
  "placeholderColor",
  "outlineColor",
  "colorTransparent",
  "blue1",
  "blue2",
  "blue3",
  "blue4",
  "blue5",
  "blue6",
  "blue7",
  "blue8",
  "blue9",
  "blue10",
  "blue11",
  "blue12",
  "red1",
  "red2",
  "red3",
  "red4",
  "red5",
  "red6",
  "red7",
  "red8",
  "red9",
  "red10",
  "red11",
  "red12",
  "yellow1",
  "yellow2",
  "yellow3",
  "yellow4",
  "yellow5",
  "yellow6",
  "yellow7",
  "yellow8",
  "yellow9",
  "yellow10",
  "yellow11",
  "yellow12",
  "green1",
  "green2",
  "green3",
  "green4",
  "green5",
  "green6",
  "green7",
  "green8",
  "green9",
  "green10",
  "green11",
  "green12",
  "shadow1",
  "shadow2",
  "shadow3",
  "shadow4",
  "shadow5",
  "shadow6",
  "black1",
  "black2",
  "black3",
  "black4",
  "black5",
  "black6",
  "black7",
  "black8",
  "black9",
  "black10",
  "black11",
  "black12",
  "white1",
  "white2",
  "white3",
  "white4",
  "white5",
  "white6",
  "white7",
  "white8",
  "white9",
  "white10",
  "white11",
  "white12",
  "shadowColor",
  "accent1",
  "accent2",
  "accent3",
  "accent4",
  "accent5",
  "accent6",
  "accent7",
  "accent8",
  "accent9",
  "accent10",
  "accent11",
  "accent12"
];
var n1 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    2
  ],
  [
    3,
    3
  ],
  [
    4,
    4
  ],
  [
    5,
    5
  ],
  [
    6,
    6
  ],
  [
    7,
    7
  ],
  [
    8,
    8
  ],
  [
    9,
    9
  ],
  [
    10,
    10
  ],
  [
    11,
    11
  ],
  [
    12,
    12
  ],
  [
    13,
    13
  ],
  [
    14,
    14
  ],
  [
    15,
    15
  ],
  [
    16,
    16
  ],
  [
    17,
    17
  ],
  [
    18,
    18
  ],
  [
    19,
    19
  ],
  [
    20,
    20
  ],
  [
    21,
    21
  ],
  [
    22,
    22
  ],
  [
    23,
    23
  ],
  [
    24,
    7
  ],
  [
    25,
    9
  ],
  [
    26,
    10
  ],
  [
    27,
    9
  ],
  [
    28,
    10
  ],
  [
    29,
    9
  ],
  [
    30,
    11
  ],
  [
    31,
    10
  ],
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    38,
    19
  ],
  [
    39,
    24
  ],
  [
    40,
    25
  ],
  [
    41,
    26
  ],
  [
    42,
    27
  ],
  [
    43,
    28
  ],
  [
    44,
    29
  ],
  [
    45,
    30
  ],
  [
    46,
    31
  ],
  [
    47,
    32
  ],
  [
    48,
    33
  ],
  [
    49,
    34
  ],
  [
    50,
    35
  ],
  [
    51,
    36
  ],
  [
    52,
    37
  ],
  [
    53,
    38
  ],
  [
    54,
    39
  ],
  [
    55,
    40
  ],
  [
    56,
    41
  ],
  [
    57,
    42
  ],
  [
    58,
    43
  ],
  [
    59,
    44
  ],
  [
    60,
    45
  ],
  [
    61,
    46
  ],
  [
    62,
    47
  ],
  [
    63,
    48
  ],
  [
    64,
    49
  ],
  [
    65,
    50
  ],
  [
    66,
    51
  ],
  [
    67,
    52
  ],
  [
    68,
    53
  ],
  [
    69,
    54
  ],
  [
    70,
    55
  ],
  [
    71,
    56
  ],
  [
    72,
    57
  ],
  [
    73,
    58
  ],
  [
    74,
    59
  ],
  [
    75,
    60
  ],
  [
    76,
    61
  ],
  [
    77,
    62
  ],
  [
    78,
    63
  ],
  [
    79,
    64
  ],
  [
    80,
    65
  ],
  [
    81,
    66
  ],
  [
    82,
    67
  ],
  [
    83,
    68
  ],
  [
    84,
    69
  ],
  [
    85,
    70
  ],
  [
    86,
    71
  ],
  [
    87,
    72
  ],
  [
    88,
    73
  ],
  [
    89,
    74
  ],
  [
    90,
    75
  ],
  [
    91,
    76
  ],
  [
    92,
    77
  ],
  [
    93,
    78
  ],
  [
    94,
    79
  ],
  [
    95,
    80
  ],
  [
    96,
    81
  ],
  [
    97,
    82
  ],
  [
    98,
    83
  ],
  [
    99,
    84
  ],
  [
    100,
    85
  ],
  [
    101,
    86
  ],
  [
    102,
    87
  ],
  [
    103,
    88
  ],
  [
    104,
    89
  ],
  [
    105,
    89
  ],
  [
    106,
    90
  ],
  [
    107,
    91
  ],
  [
    108,
    92
  ],
  [
    109,
    93
  ],
  [
    110,
    94
  ],
  [
    111,
    95
  ],
  [
    112,
    96
  ],
  [
    113,
    97
  ],
  [
    114,
    98
  ],
  [
    115,
    99
  ],
  [
    116,
    100
  ],
  [
    117,
    72
  ],
  [
    118,
    101
  ],
  [
    119,
    102
  ],
  [
    120,
    0
  ],
  [
    121,
    103
  ],
  [
    122,
    104
  ],
  [
    123,
    105
  ],
  [
    124,
    106
  ],
  [
    125,
    107
  ],
  [
    126,
    108
  ],
  [
    127,
    1
  ],
  [
    128,
    109
  ],
  [
    129,
    7
  ]
]);
var n2 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    110
  ],
  [
    3,
    111
  ],
  [
    4,
    112
  ],
  [
    5,
    113
  ],
  [
    6,
    114
  ],
  [
    7,
    101
  ],
  [
    8,
    102
  ],
  [
    9,
    0
  ],
  [
    10,
    103
  ],
  [
    11,
    104
  ],
  [
    12,
    105
  ],
  [
    13,
    106
  ],
  [
    14,
    107
  ],
  [
    15,
    108
  ],
  [
    16,
    1
  ],
  [
    17,
    109
  ],
  [
    18,
    7
  ],
  [
    19,
    2
  ],
  [
    20,
    3
  ],
  [
    21,
    4
  ],
  [
    22,
    5
  ],
  [
    23,
    6
  ],
  [
    24,
    101
  ],
  [
    25,
    0
  ],
  [
    26,
    103
  ],
  [
    27,
    0
  ],
  [
    28,
    103
  ],
  [
    29,
    104
  ],
  [
    30,
    0
  ],
  [
    31,
    103
  ],
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    38,
    2
  ],
  [
    39,
    115
  ],
  [
    40,
    116
  ],
  [
    41,
    117
  ],
  [
    42,
    118
  ],
  [
    43,
    119
  ],
  [
    44,
    120
  ],
  [
    45,
    121
  ],
  [
    46,
    122
  ],
  [
    47,
    32
  ],
  [
    48,
    123
  ],
  [
    49,
    124
  ],
  [
    50,
    125
  ],
  [
    51,
    126
  ],
  [
    52,
    127
  ],
  [
    53,
    128
  ],
  [
    54,
    129
  ],
  [
    55,
    130
  ],
  [
    56,
    131
  ],
  [
    57,
    132
  ],
  [
    58,
    133
  ],
  [
    59,
    44
  ],
  [
    60,
    134
  ],
  [
    61,
    135
  ],
  [
    62,
    136
  ],
  [
    63,
    137
  ],
  [
    64,
    138
  ],
  [
    65,
    139
  ],
  [
    66,
    140
  ],
  [
    67,
    141
  ],
  [
    68,
    142
  ],
  [
    69,
    143
  ],
  [
    70,
    144
  ],
  [
    71,
    56
  ],
  [
    72,
    145
  ],
  [
    73,
    146
  ],
  [
    74,
    147
  ],
  [
    75,
    148
  ],
  [
    76,
    149
  ],
  [
    77,
    150
  ],
  [
    78,
    151
  ],
  [
    79,
    152
  ],
  [
    80,
    153
  ],
  [
    81,
    154
  ],
  [
    82,
    155
  ],
  [
    83,
    68
  ],
  [
    84,
    156
  ],
  [
    85,
    157
  ],
  [
    86,
    158
  ],
  [
    87,
    159
  ],
  [
    88,
    160
  ],
  [
    89,
    77
  ],
  [
    90,
    161
  ],
  [
    91,
    162
  ],
  [
    92,
    163
  ],
  [
    93,
    78
  ],
  [
    94,
    79
  ],
  [
    95,
    80
  ],
  [
    96,
    81
  ],
  [
    97,
    82
  ],
  [
    98,
    83
  ],
  [
    99,
    84
  ],
  [
    100,
    85
  ],
  [
    101,
    86
  ],
  [
    102,
    87
  ],
  [
    103,
    88
  ],
  [
    104,
    89
  ],
  [
    105,
    89
  ],
  [
    106,
    90
  ],
  [
    107,
    91
  ],
  [
    108,
    92
  ],
  [
    109,
    93
  ],
  [
    110,
    94
  ],
  [
    111,
    95
  ],
  [
    112,
    96
  ],
  [
    113,
    97
  ],
  [
    114,
    98
  ],
  [
    115,
    99
  ],
  [
    116,
    100
  ],
  [
    117,
    159
  ],
  [
    118,
    7
  ],
  [
    119,
    8
  ],
  [
    120,
    9
  ],
  [
    121,
    10
  ],
  [
    122,
    11
  ],
  [
    123,
    12
  ],
  [
    124,
    13
  ],
  [
    125,
    14
  ],
  [
    126,
    15
  ],
  [
    127,
    16
  ],
  [
    128,
    17
  ],
  [
    129,
    18
  ]
]);
var n3 = t([
  [
    0,
    1
  ],
  [
    1,
    0
  ],
  [
    2,
    19
  ],
  [
    3,
    20
  ],
  [
    4,
    21
  ],
  [
    5,
    22
  ],
  [
    6,
    23
  ],
  [
    7,
    18
  ],
  [
    8,
    17
  ],
  [
    9,
    16
  ],
  [
    10,
    15
  ],
  [
    11,
    14
  ],
  [
    12,
    13
  ],
  [
    13,
    12
  ],
  [
    14,
    11
  ],
  [
    15,
    10
  ],
  [
    16,
    9
  ],
  [
    17,
    8
  ],
  [
    18,
    7
  ],
  [
    19,
    2
  ],
  [
    20,
    3
  ],
  [
    21,
    4
  ],
  [
    22,
    5
  ],
  [
    23,
    6
  ],
  [
    24,
    18
  ],
  [
    25,
    16
  ],
  [
    26,
    15
  ],
  [
    27,
    16
  ],
  [
    28,
    15
  ],
  [
    29,
    16
  ],
  [
    30,
    14
  ],
  [
    31,
    15
  ],
  [
    32,
    7
  ],
  [
    33,
    8
  ],
  [
    34,
    7
  ],
  [
    35,
    8
  ],
  [
    36,
    10
  ],
  [
    37,
    3
  ],
  [
    38,
    2
  ]
]);
var n4 = t([
  [
    0,
    9
  ],
  [
    1,
    16
  ],
  [
    2,
    2
  ],
  [
    3,
    3
  ],
  [
    4,
    4
  ],
  [
    5,
    5
  ],
  [
    6,
    6
  ],
  [
    7,
    7
  ],
  [
    8,
    109
  ],
  [
    9,
    1
  ],
  [
    10,
    108
  ],
  [
    11,
    107
  ],
  [
    12,
    106
  ],
  [
    13,
    105
  ],
  [
    14,
    104
  ],
  [
    15,
    103
  ],
  [
    16,
    0
  ],
  [
    17,
    102
  ],
  [
    18,
    101
  ],
  [
    19,
    110
  ],
  [
    20,
    111
  ],
  [
    21,
    112
  ],
  [
    22,
    113
  ],
  [
    23,
    114
  ],
  [
    24,
    7
  ],
  [
    25,
    1
  ],
  [
    26,
    108
  ],
  [
    27,
    1
  ],
  [
    28,
    108
  ],
  [
    29,
    107
  ],
  [
    30,
    1
  ],
  [
    31,
    108
  ],
  [
    32,
    101
  ],
  [
    33,
    102
  ],
  [
    34,
    101
  ],
  [
    35,
    102
  ],
  [
    36,
    103
  ],
  [
    37,
    111
  ],
  [
    38,
    110
  ]
]);
var n5 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    110
  ],
  [
    3,
    111
  ],
  [
    4,
    112
  ],
  [
    5,
    113
  ],
  [
    6,
    114
  ],
  [
    7,
    101
  ],
  [
    8,
    102
  ],
  [
    9,
    0
  ],
  [
    10,
    103
  ],
  [
    11,
    104
  ],
  [
    12,
    105
  ],
  [
    13,
    106
  ],
  [
    14,
    107
  ],
  [
    15,
    108
  ],
  [
    16,
    1
  ],
  [
    17,
    109
  ],
  [
    18,
    7
  ],
  [
    19,
    2
  ],
  [
    20,
    3
  ],
  [
    21,
    4
  ],
  [
    22,
    5
  ],
  [
    23,
    6
  ],
  [
    24,
    101
  ],
  [
    25,
    0
  ],
  [
    26,
    103
  ],
  [
    27,
    0
  ],
  [
    28,
    103
  ],
  [
    29,
    0
  ],
  [
    30,
    104
  ],
  [
    31,
    103
  ],
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    38,
    2
  ]
]);
var n6 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    2
  ],
  [
    3,
    3
  ],
  [
    4,
    4
  ],
  [
    5,
    5
  ],
  [
    6,
    6
  ],
  [
    7,
    7
  ],
  [
    8,
    8
  ],
  [
    9,
    9
  ],
  [
    10,
    10
  ],
  [
    11,
    11
  ],
  [
    12,
    12
  ],
  [
    13,
    13
  ],
  [
    14,
    14
  ],
  [
    15,
    15
  ],
  [
    16,
    16
  ],
  [
    17,
    17
  ],
  [
    18,
    18
  ],
  [
    19,
    19
  ],
  [
    20,
    20
  ],
  [
    21,
    21
  ],
  [
    22,
    22
  ],
  [
    23,
    23
  ],
  [
    24,
    7
  ],
  [
    25,
    9
  ],
  [
    26,
    10
  ],
  [
    27,
    9
  ],
  [
    28,
    10
  ],
  [
    29,
    9
  ],
  [
    30,
    11
  ],
  [
    31,
    10
  ],
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    38,
    19
  ]
]);
var n7 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    164
  ],
  [
    3,
    165
  ],
  [
    4,
    166
  ],
  [
    5,
    167
  ],
  [
    6,
    168
  ],
  [
    7,
    169
  ],
  [
    8,
    170
  ],
  [
    9,
    171
  ],
  [
    10,
    172
  ],
  [
    11,
    173
  ],
  [
    12,
    174
  ],
  [
    13,
    175
  ],
  [
    14,
    176
  ],
  [
    15,
    177
  ],
  [
    16,
    178
  ],
  [
    17,
    179
  ],
  [
    18,
    180
  ],
  [
    19,
    181
  ],
  [
    20,
    182
  ],
  [
    21,
    183
  ],
  [
    22,
    184
  ],
  [
    23,
    185
  ],
  [
    24,
    169
  ],
  [
    25,
    171
  ],
  [
    26,
    172
  ],
  [
    27,
    171
  ],
  [
    28,
    172
  ],
  [
    29,
    171
  ],
  [
    30,
    173
  ],
  [
    31,
    172
  ],
  [
    32,
    180
  ],
  [
    33,
    179
  ],
  [
    34,
    180
  ],
  [
    35,
    179
  ],
  [
    36,
    177
  ],
  [
    37,
    182
  ],
  [
    38,
    181
  ]
]);
var n8 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    186
  ],
  [
    3,
    187
  ],
  [
    4,
    188
  ],
  [
    5,
    189
  ],
  [
    6,
    190
  ],
  [
    7,
    191
  ],
  [
    8,
    191
  ],
  [
    9,
    192
  ],
  [
    10,
    193
  ],
  [
    11,
    194
  ],
  [
    12,
    195
  ],
  [
    13,
    196
  ],
  [
    14,
    197
  ],
  [
    15,
    198
  ],
  [
    16,
    199
  ],
  [
    17,
    200
  ],
  [
    18,
    201
  ],
  [
    19,
    202
  ],
  [
    20,
    203
  ],
  [
    21,
    204
  ],
  [
    22,
    205
  ],
  [
    23,
    206
  ],
  [
    24,
    191
  ],
  [
    25,
    192
  ],
  [
    26,
    193
  ],
  [
    27,
    192
  ],
  [
    28,
    193
  ],
  [
    29,
    192
  ],
  [
    30,
    194
  ],
  [
    31,
    193
  ],
  [
    32,
    201
  ],
  [
    33,
    200
  ],
  [
    34,
    201
  ],
  [
    35,
    200
  ],
  [
    36,
    198
  ],
  [
    37,
    203
  ],
  [
    38,
    202
  ]
]);
var n9 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    207
  ],
  [
    3,
    208
  ],
  [
    4,
    209
  ],
  [
    5,
    210
  ],
  [
    6,
    211
  ],
  [
    7,
    212
  ],
  [
    8,
    213
  ],
  [
    9,
    214
  ],
  [
    10,
    215
  ],
  [
    11,
    216
  ],
  [
    12,
    217
  ],
  [
    13,
    218
  ],
  [
    14,
    219
  ],
  [
    15,
    220
  ],
  [
    16,
    221
  ],
  [
    17,
    222
  ],
  [
    18,
    223
  ],
  [
    19,
    224
  ],
  [
    20,
    225
  ],
  [
    21,
    226
  ],
  [
    22,
    227
  ],
  [
    23,
    228
  ],
  [
    24,
    212
  ],
  [
    25,
    214
  ],
  [
    26,
    215
  ],
  [
    27,
    214
  ],
  [
    28,
    215
  ],
  [
    29,
    214
  ],
  [
    30,
    216
  ],
  [
    31,
    215
  ],
  [
    32,
    223
  ],
  [
    33,
    222
  ],
  [
    34,
    223
  ],
  [
    35,
    222
  ],
  [
    36,
    220
  ],
  [
    37,
    225
  ],
  [
    38,
    224
  ]
]);
var n10 = t([
  [
    0,
    0
  ],
  [
    1,
    1
  ],
  [
    2,
    229
  ],
  [
    3,
    230
  ],
  [
    4,
    231
  ],
  [
    5,
    232
  ],
  [
    6,
    233
  ],
  [
    7,
    234
  ],
  [
    8,
    235
  ],
  [
    9,
    236
  ],
  [
    10,
    237
  ],
  [
    11,
    238
  ],
  [
    12,
    239
  ],
  [
    13,
    240
  ],
  [
    14,
    241
  ],
  [
    15,
    242
  ],
  [
    16,
    243
  ],
  [
    17,
    244
  ],
  [
    18,
    245
  ],
  [
    19,
    246
  ],
  [
    20,
    247
  ],
  [
    21,
    248
  ],
  [
    22,
    249
  ],
  [
    23,
    250
  ],
  [
    24,
    234
  ],
  [
    25,
    236
  ],
  [
    26,
    237
  ],
  [
    27,
    236
  ],
  [
    28,
    237
  ],
  [
    29,
    236
  ],
  [
    30,
    238
  ],
  [
    31,
    237
  ],
  [
    32,
    245
  ],
  [
    33,
    244
  ],
  [
    34,
    245
  ],
  [
    35,
    244
  ],
  [
    36,
    242
  ],
  [
    37,
    247
  ],
  [
    38,
    246
  ]
]);
var n11 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    110
  ],
  [
    3,
    111
  ],
  [
    4,
    112
  ],
  [
    5,
    113
  ],
  [
    6,
    114
  ],
  [
    7,
    101
  ],
  [
    8,
    102
  ],
  [
    9,
    0
  ],
  [
    10,
    103
  ],
  [
    11,
    104
  ],
  [
    12,
    105
  ],
  [
    13,
    106
  ],
  [
    14,
    107
  ],
  [
    15,
    108
  ],
  [
    16,
    1
  ],
  [
    17,
    109
  ],
  [
    18,
    7
  ],
  [
    19,
    2
  ],
  [
    20,
    3
  ],
  [
    21,
    4
  ],
  [
    22,
    5
  ],
  [
    23,
    6
  ],
  [
    24,
    101
  ],
  [
    25,
    0
  ],
  [
    26,
    103
  ],
  [
    27,
    0
  ],
  [
    28,
    103
  ],
  [
    29,
    104
  ],
  [
    30,
    0
  ],
  [
    31,
    103
  ],
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    38,
    2
  ]
]);
var n12 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    2
  ],
  [
    3,
    3
  ],
  [
    4,
    4
  ],
  [
    5,
    5
  ],
  [
    6,
    6
  ],
  [
    7,
    7
  ],
  [
    8,
    8
  ],
  [
    9,
    9
  ],
  [
    10,
    10
  ],
  [
    11,
    11
  ],
  [
    12,
    12
  ],
  [
    13,
    13
  ],
  [
    14,
    14
  ],
  [
    15,
    15
  ],
  [
    16,
    16
  ],
  [
    17,
    17
  ],
  [
    18,
    18
  ],
  [
    19,
    19
  ],
  [
    20,
    20
  ],
  [
    21,
    21
  ],
  [
    22,
    22
  ],
  [
    23,
    23
  ],
  [
    24,
    7
  ],
  [
    25,
    9
  ],
  [
    26,
    10
  ],
  [
    27,
    9
  ],
  [
    28,
    10
  ],
  [
    29,
    11
  ],
  [
    30,
    9
  ],
  [
    31,
    10
  ],
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    38,
    19
  ]
]);
var n13 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    251
  ],
  [
    3,
    252
  ],
  [
    4,
    253
  ],
  [
    5,
    254
  ],
  [
    6,
    255
  ],
  [
    7,
    256
  ],
  [
    8,
    257
  ],
  [
    9,
    258
  ],
  [
    10,
    259
  ],
  [
    11,
    260
  ],
  [
    12,
    261
  ],
  [
    13,
    262
  ],
  [
    14,
    263
  ],
  [
    15,
    177
  ],
  [
    16,
    264
  ],
  [
    17,
    265
  ],
  [
    18,
    266
  ],
  [
    19,
    267
  ],
  [
    20,
    268
  ],
  [
    21,
    269
  ],
  [
    22,
    270
  ],
  [
    23,
    271
  ],
  [
    24,
    256
  ],
  [
    25,
    258
  ],
  [
    26,
    259
  ],
  [
    27,
    258
  ],
  [
    28,
    259
  ],
  [
    29,
    260
  ],
  [
    30,
    258
  ],
  [
    31,
    259
  ],
  [
    32,
    266
  ],
  [
    33,
    265
  ],
  [
    34,
    266
  ],
  [
    35,
    265
  ],
  [
    36,
    177
  ],
  [
    37,
    268
  ],
  [
    38,
    267
  ]
]);
var n14 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    272
  ],
  [
    3,
    273
  ],
  [
    4,
    274
  ],
  [
    5,
    275
  ],
  [
    6,
    276
  ],
  [
    7,
    277
  ],
  [
    8,
    278
  ],
  [
    9,
    279
  ],
  [
    10,
    280
  ],
  [
    11,
    281
  ],
  [
    12,
    282
  ],
  [
    13,
    283
  ],
  [
    14,
    284
  ],
  [
    15,
    198
  ],
  [
    16,
    285
  ],
  [
    17,
    286
  ],
  [
    18,
    287
  ],
  [
    19,
    288
  ],
  [
    20,
    289
  ],
  [
    21,
    290
  ],
  [
    22,
    291
  ],
  [
    23,
    292
  ],
  [
    24,
    277
  ],
  [
    25,
    279
  ],
  [
    26,
    280
  ],
  [
    27,
    279
  ],
  [
    28,
    280
  ],
  [
    29,
    281
  ],
  [
    30,
    279
  ],
  [
    31,
    280
  ],
  [
    32,
    287
  ],
  [
    33,
    286
  ],
  [
    34,
    287
  ],
  [
    35,
    286
  ],
  [
    36,
    198
  ],
  [
    37,
    289
  ],
  [
    38,
    288
  ]
]);
var n15 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    293
  ],
  [
    3,
    294
  ],
  [
    4,
    295
  ],
  [
    5,
    296
  ],
  [
    6,
    297
  ],
  [
    7,
    298
  ],
  [
    8,
    299
  ],
  [
    9,
    300
  ],
  [
    10,
    301
  ],
  [
    11,
    302
  ],
  [
    12,
    303
  ],
  [
    13,
    304
  ],
  [
    14,
    305
  ],
  [
    15,
    220
  ],
  [
    16,
    306
  ],
  [
    17,
    307
  ],
  [
    18,
    308
  ],
  [
    19,
    309
  ],
  [
    20,
    310
  ],
  [
    21,
    311
  ],
  [
    22,
    312
  ],
  [
    23,
    313
  ],
  [
    24,
    298
  ],
  [
    25,
    300
  ],
  [
    26,
    301
  ],
  [
    27,
    300
  ],
  [
    28,
    301
  ],
  [
    29,
    302
  ],
  [
    30,
    300
  ],
  [
    31,
    301
  ],
  [
    32,
    308
  ],
  [
    33,
    307
  ],
  [
    34,
    308
  ],
  [
    35,
    307
  ],
  [
    36,
    220
  ],
  [
    37,
    310
  ],
  [
    38,
    309
  ]
]);
var n16 = t([
  [
    0,
    16
  ],
  [
    1,
    9
  ],
  [
    2,
    314
  ],
  [
    3,
    315
  ],
  [
    4,
    316
  ],
  [
    5,
    317
  ],
  [
    6,
    318
  ],
  [
    7,
    319
  ],
  [
    8,
    320
  ],
  [
    9,
    321
  ],
  [
    10,
    322
  ],
  [
    11,
    323
  ],
  [
    12,
    324
  ],
  [
    13,
    325
  ],
  [
    14,
    326
  ],
  [
    15,
    242
  ],
  [
    16,
    327
  ],
  [
    17,
    328
  ],
  [
    18,
    329
  ],
  [
    19,
    330
  ],
  [
    20,
    331
  ],
  [
    21,
    332
  ],
  [
    22,
    333
  ],
  [
    23,
    334
  ],
  [
    24,
    319
  ],
  [
    25,
    321
  ],
  [
    26,
    322
  ],
  [
    27,
    321
  ],
  [
    28,
    322
  ],
  [
    29,
    323
  ],
  [
    30,
    321
  ],
  [
    31,
    322
  ],
  [
    32,
    329
  ],
  [
    33,
    328
  ],
  [
    34,
    329
  ],
  [
    35,
    328
  ],
  [
    36,
    242
  ],
  [
    37,
    331
  ],
  [
    38,
    330
  ]
]);
var n17 = t([
  [
    0,
    1
  ],
  [
    1,
    0
  ],
  [
    2,
    2
  ],
  [
    3,
    3
  ],
  [
    4,
    4
  ],
  [
    5,
    5
  ],
  [
    6,
    6
  ],
  [
    7,
    7
  ],
  [
    8,
    109
  ],
  [
    9,
    1
  ],
  [
    10,
    108
  ],
  [
    11,
    107
  ],
  [
    12,
    106
  ],
  [
    13,
    105
  ],
  [
    14,
    104
  ],
  [
    15,
    103
  ],
  [
    16,
    0
  ],
  [
    17,
    102
  ],
  [
    18,
    101
  ],
  [
    19,
    110
  ],
  [
    20,
    111
  ],
  [
    21,
    112
  ],
  [
    22,
    113
  ],
  [
    23,
    114
  ],
  [
    24,
    7
  ],
  [
    25,
    1
  ],
  [
    26,
    108
  ],
  [
    27,
    1
  ],
  [
    28,
    108
  ],
  [
    29,
    1
  ],
  [
    30,
    107
  ],
  [
    31,
    108
  ],
  [
    32,
    101
  ],
  [
    33,
    102
  ],
  [
    34,
    101
  ],
  [
    35,
    102
  ],
  [
    36,
    103
  ],
  [
    37,
    111
  ],
  [
    38,
    110
  ]
]);
var n18 = t([
  [
    0,
    1
  ],
  [
    1,
    0
  ],
  [
    2,
    181
  ],
  [
    3,
    182
  ],
  [
    4,
    183
  ],
  [
    5,
    184
  ],
  [
    6,
    185
  ],
  [
    7,
    180
  ],
  [
    8,
    179
  ],
  [
    9,
    178
  ],
  [
    10,
    177
  ],
  [
    11,
    176
  ],
  [
    12,
    175
  ],
  [
    13,
    174
  ],
  [
    14,
    173
  ],
  [
    15,
    172
  ],
  [
    16,
    171
  ],
  [
    17,
    170
  ],
  [
    18,
    169
  ],
  [
    19,
    164
  ],
  [
    20,
    165
  ],
  [
    21,
    166
  ],
  [
    22,
    167
  ],
  [
    23,
    168
  ],
  [
    24,
    180
  ],
  [
    25,
    178
  ],
  [
    26,
    177
  ],
  [
    27,
    178
  ],
  [
    28,
    177
  ],
  [
    29,
    178
  ],
  [
    30,
    176
  ],
  [
    31,
    177
  ],
  [
    32,
    169
  ],
  [
    33,
    170
  ],
  [
    34,
    169
  ],
  [
    35,
    170
  ],
  [
    36,
    172
  ],
  [
    37,
    165
  ],
  [
    38,
    164
  ]
]);
var n19 = t([
  [
    0,
    1
  ],
  [
    1,
    0
  ],
  [
    2,
    202
  ],
  [
    3,
    203
  ],
  [
    4,
    204
  ],
  [
    5,
    205
  ],
  [
    6,
    206
  ],
  [
    7,
    201
  ],
  [
    8,
    200
  ],
  [
    9,
    199
  ],
  [
    10,
    198
  ],
  [
    11,
    197
  ],
  [
    12,
    196
  ],
  [
    13,
    195
  ],
  [
    14,
    194
  ],
  [
    15,
    193
  ],
  [
    16,
    192
  ],
  [
    17,
    191
  ],
  [
    18,
    191
  ],
  [
    19,
    186
  ],
  [
    20,
    187
  ],
  [
    21,
    188
  ],
  [
    22,
    189
  ],
  [
    23,
    190
  ],
  [
    24,
    201
  ],
  [
    25,
    199
  ],
  [
    26,
    198
  ],
  [
    27,
    199
  ],
  [
    28,
    198
  ],
  [
    29,
    199
  ],
  [
    30,
    197
  ],
  [
    31,
    198
  ],
  [
    32,
    191
  ],
  [
    33,
    191
  ],
  [
    34,
    191
  ],
  [
    35,
    191
  ],
  [
    36,
    193
  ],
  [
    37,
    187
  ],
  [
    38,
    186
  ]
]);
var n20 = t([
  [
    0,
    1
  ],
  [
    1,
    0
  ],
  [
    2,
    224
  ],
  [
    3,
    225
  ],
  [
    4,
    226
  ],
  [
    5,
    227
  ],
  [
    6,
    228
  ],
  [
    7,
    223
  ],
  [
    8,
    222
  ],
  [
    9,
    221
  ],
  [
    10,
    220
  ],
  [
    11,
    219
  ],
  [
    12,
    218
  ],
  [
    13,
    217
  ],
  [
    14,
    216
  ],
  [
    15,
    215
  ],
  [
    16,
    214
  ],
  [
    17,
    213
  ],
  [
    18,
    212
  ],
  [
    19,
    207
  ],
  [
    20,
    208
  ],
  [
    21,
    209
  ],
  [
    22,
    210
  ],
  [
    23,
    211
  ],
  [
    24,
    223
  ],
  [
    25,
    221
  ],
  [
    26,
    220
  ],
  [
    27,
    221
  ],
  [
    28,
    220
  ],
  [
    29,
    221
  ],
  [
    30,
    219
  ],
  [
    31,
    220
  ],
  [
    32,
    212
  ],
  [
    33,
    213
  ],
  [
    34,
    212
  ],
  [
    35,
    213
  ],
  [
    36,
    215
  ],
  [
    37,
    208
  ],
  [
    38,
    207
  ]
]);
var n21 = t([
  [
    0,
    1
  ],
  [
    1,
    0
  ],
  [
    2,
    246
  ],
  [
    3,
    247
  ],
  [
    4,
    248
  ],
  [
    5,
    249
  ],
  [
    6,
    250
  ],
  [
    7,
    245
  ],
  [
    8,
    244
  ],
  [
    9,
    243
  ],
  [
    10,
    242
  ],
  [
    11,
    241
  ],
  [
    12,
    240
  ],
  [
    13,
    239
  ],
  [
    14,
    238
  ],
  [
    15,
    237
  ],
  [
    16,
    236
  ],
  [
    17,
    235
  ],
  [
    18,
    234
  ],
  [
    19,
    229
  ],
  [
    20,
    230
  ],
  [
    21,
    231
  ],
  [
    22,
    232
  ],
  [
    23,
    233
  ],
  [
    24,
    245
  ],
  [
    25,
    243
  ],
  [
    26,
    242
  ],
  [
    27,
    243
  ],
  [
    28,
    242
  ],
  [
    29,
    243
  ],
  [
    30,
    241
  ],
  [
    31,
    242
  ],
  [
    32,
    234
  ],
  [
    33,
    235
  ],
  [
    34,
    234
  ],
  [
    35,
    235
  ],
  [
    36,
    237
  ],
  [
    37,
    230
  ],
  [
    38,
    229
  ]
]);
var n22 = t([
  [
    0,
    9
  ],
  [
    1,
    16
  ],
  [
    2,
    19
  ],
  [
    3,
    20
  ],
  [
    4,
    21
  ],
  [
    5,
    22
  ],
  [
    6,
    23
  ],
  [
    7,
    18
  ],
  [
    8,
    17
  ],
  [
    9,
    16
  ],
  [
    10,
    15
  ],
  [
    11,
    14
  ],
  [
    12,
    13
  ],
  [
    13,
    12
  ],
  [
    14,
    11
  ],
  [
    15,
    10
  ],
  [
    16,
    9
  ],
  [
    17,
    8
  ],
  [
    18,
    7
  ],
  [
    19,
    2
  ],
  [
    20,
    3
  ],
  [
    21,
    4
  ],
  [
    22,
    5
  ],
  [
    23,
    6
  ],
  [
    24,
    18
  ],
  [
    25,
    16
  ],
  [
    26,
    15
  ],
  [
    27,
    16
  ],
  [
    28,
    15
  ],
  [
    29,
    14
  ],
  [
    30,
    16
  ],
  [
    31,
    15
  ],
  [
    32,
    7
  ],
  [
    33,
    8
  ],
  [
    34,
    7
  ],
  [
    35,
    8
  ],
  [
    36,
    10
  ],
  [
    37,
    3
  ],
  [
    38,
    2
  ]
]);
var n23 = t([
  [
    0,
    9
  ],
  [
    1,
    16
  ],
  [
    2,
    267
  ],
  [
    3,
    268
  ],
  [
    4,
    269
  ],
  [
    5,
    270
  ],
  [
    6,
    271
  ],
  [
    7,
    266
  ],
  [
    8,
    265
  ],
  [
    9,
    264
  ],
  [
    10,
    177
  ],
  [
    11,
    263
  ],
  [
    12,
    262
  ],
  [
    13,
    261
  ],
  [
    14,
    260
  ],
  [
    15,
    259
  ],
  [
    16,
    258
  ],
  [
    17,
    257
  ],
  [
    18,
    256
  ],
  [
    19,
    251
  ],
  [
    20,
    252
  ],
  [
    21,
    253
  ],
  [
    22,
    254
  ],
  [
    23,
    255
  ],
  [
    24,
    266
  ],
  [
    25,
    264
  ],
  [
    26,
    177
  ],
  [
    27,
    264
  ],
  [
    28,
    177
  ],
  [
    29,
    263
  ],
  [
    30,
    264
  ],
  [
    31,
    177
  ],
  [
    32,
    256
  ],
  [
    33,
    257
  ],
  [
    34,
    256
  ],
  [
    35,
    257
  ],
  [
    36,
    259
  ],
  [
    37,
    252
  ],
  [
    38,
    251
  ]
]);
var n24 = t([
  [
    0,
    9
  ],
  [
    1,
    16
  ],
  [
    2,
    288
  ],
  [
    3,
    289
  ],
  [
    4,
    290
  ],
  [
    5,
    291
  ],
  [
    6,
    292
  ],
  [
    7,
    287
  ],
  [
    8,
    286
  ],
  [
    9,
    285
  ],
  [
    10,
    198
  ],
  [
    11,
    284
  ],
  [
    12,
    283
  ],
  [
    13,
    282
  ],
  [
    14,
    281
  ],
  [
    15,
    280
  ],
  [
    16,
    279
  ],
  [
    17,
    278
  ],
  [
    18,
    277
  ],
  [
    19,
    272
  ],
  [
    20,
    273
  ],
  [
    21,
    274
  ],
  [
    22,
    275
  ],
  [
    23,
    276
  ],
  [
    24,
    287
  ],
  [
    25,
    285
  ],
  [
    26,
    198
  ],
  [
    27,
    285
  ],
  [
    28,
    198
  ],
  [
    29,
    284
  ],
  [
    30,
    285
  ],
  [
    31,
    198
  ],
  [
    32,
    277
  ],
  [
    33,
    278
  ],
  [
    34,
    277
  ],
  [
    35,
    278
  ],
  [
    36,
    280
  ],
  [
    37,
    273
  ],
  [
    38,
    272
  ]
]);
var n25 = t([
  [
    0,
    9
  ],
  [
    1,
    16
  ],
  [
    2,
    309
  ],
  [
    3,
    310
  ],
  [
    4,
    311
  ],
  [
    5,
    312
  ],
  [
    6,
    313
  ],
  [
    7,
    308
  ],
  [
    8,
    307
  ],
  [
    9,
    306
  ],
  [
    10,
    220
  ],
  [
    11,
    305
  ],
  [
    12,
    304
  ],
  [
    13,
    303
  ],
  [
    14,
    302
  ],
  [
    15,
    301
  ],
  [
    16,
    300
  ],
  [
    17,
    299
  ],
  [
    18,
    298
  ],
  [
    19,
    293
  ],
  [
    20,
    294
  ],
  [
    21,
    295
  ],
  [
    22,
    296
  ],
  [
    23,
    297
  ],
  [
    24,
    308
  ],
  [
    25,
    306
  ],
  [
    26,
    220
  ],
  [
    27,
    306
  ],
  [
    28,
    220
  ],
  [
    29,
    305
  ],
  [
    30,
    306
  ],
  [
    31,
    220
  ],
  [
    32,
    298
  ],
  [
    33,
    299
  ],
  [
    34,
    298
  ],
  [
    35,
    299
  ],
  [
    36,
    301
  ],
  [
    37,
    294
  ],
  [
    38,
    293
  ]
]);
var n26 = t([
  [
    0,
    9
  ],
  [
    1,
    16
  ],
  [
    2,
    330
  ],
  [
    3,
    331
  ],
  [
    4,
    332
  ],
  [
    5,
    333
  ],
  [
    6,
    334
  ],
  [
    7,
    329
  ],
  [
    8,
    328
  ],
  [
    9,
    327
  ],
  [
    10,
    242
  ],
  [
    11,
    326
  ],
  [
    12,
    325
  ],
  [
    13,
    324
  ],
  [
    14,
    323
  ],
  [
    15,
    322
  ],
  [
    16,
    321
  ],
  [
    17,
    320
  ],
  [
    18,
    319
  ],
  [
    19,
    314
  ],
  [
    20,
    315
  ],
  [
    21,
    316
  ],
  [
    22,
    317
  ],
  [
    23,
    318
  ],
  [
    24,
    329
  ],
  [
    25,
    327
  ],
  [
    26,
    242
  ],
  [
    27,
    327
  ],
  [
    28,
    242
  ],
  [
    29,
    326
  ],
  [
    30,
    327
  ],
  [
    31,
    242
  ],
  [
    32,
    319
  ],
  [
    33,
    320
  ],
  [
    34,
    319
  ],
  [
    35,
    320
  ],
  [
    36,
    322
  ],
  [
    37,
    315
  ],
  [
    38,
    314
  ]
]);
var n27 = t([
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    24,
    8
  ],
  [
    25,
    10
  ],
  [
    26,
    11
  ],
  [
    27,
    10
  ],
  [
    28,
    11
  ],
  [
    29,
    10
  ],
  [
    31,
    11
  ],
  [
    30,
    12
  ]
]);
var n28 = t([
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    24,
    10
  ],
  [
    25,
    12
  ],
  [
    26,
    13
  ],
  [
    27,
    12
  ],
  [
    28,
    13
  ],
  [
    29,
    12
  ],
  [
    31,
    13
  ],
  [
    30,
    14
  ]
]);
var n29 = t([
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    24,
    9
  ],
  [
    25,
    11
  ],
  [
    26,
    12
  ],
  [
    27,
    11
  ],
  [
    28,
    12
  ],
  [
    29,
    11
  ],
  [
    31,
    12
  ],
  [
    30,
    13
  ]
]);
var n30 = t([
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    24,
    102
  ],
  [
    25,
    103
  ],
  [
    26,
    104
  ],
  [
    27,
    103
  ],
  [
    28,
    104
  ],
  [
    29,
    105
  ],
  [
    31,
    104
  ],
  [
    30,
    103
  ]
]);
var n31 = t([
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    24,
    103
  ],
  [
    25,
    105
  ],
  [
    26,
    106
  ],
  [
    27,
    105
  ],
  [
    28,
    106
  ],
  [
    29,
    107
  ],
  [
    31,
    106
  ],
  [
    30,
    105
  ]
]);
var n32 = t([
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    24,
    0
  ],
  [
    25,
    104
  ],
  [
    26,
    105
  ],
  [
    27,
    104
  ],
  [
    28,
    105
  ],
  [
    29,
    106
  ],
  [
    31,
    105
  ],
  [
    30,
    104
  ]
]);
var n33 = t([
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    24,
    102
  ],
  [
    25,
    103
  ],
  [
    26,
    104
  ],
  [
    27,
    103
  ],
  [
    28,
    104
  ],
  [
    29,
    103
  ],
  [
    31,
    104
  ],
  [
    30,
    105
  ]
]);
var n34 = t([
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    24,
    103
  ],
  [
    25,
    105
  ],
  [
    26,
    106
  ],
  [
    27,
    105
  ],
  [
    28,
    106
  ],
  [
    29,
    105
  ],
  [
    31,
    106
  ],
  [
    30,
    107
  ]
]);
var n35 = t([
  [
    32,
    7
  ],
  [
    33,
    109
  ],
  [
    34,
    7
  ],
  [
    35,
    109
  ],
  [
    36,
    108
  ],
  [
    37,
    3
  ],
  [
    24,
    0
  ],
  [
    25,
    104
  ],
  [
    26,
    105
  ],
  [
    27,
    104
  ],
  [
    28,
    105
  ],
  [
    29,
    104
  ],
  [
    31,
    105
  ],
  [
    30,
    106
  ]
]);
var n36 = t([
  [
    32,
    180
  ],
  [
    33,
    179
  ],
  [
    34,
    180
  ],
  [
    35,
    179
  ],
  [
    36,
    177
  ],
  [
    37,
    182
  ],
  [
    24,
    170
  ],
  [
    25,
    172
  ],
  [
    26,
    173
  ],
  [
    27,
    172
  ],
  [
    28,
    173
  ],
  [
    29,
    172
  ],
  [
    31,
    173
  ],
  [
    30,
    174
  ]
]);
var n37 = t([
  [
    32,
    180
  ],
  [
    33,
    179
  ],
  [
    34,
    180
  ],
  [
    35,
    179
  ],
  [
    36,
    177
  ],
  [
    37,
    182
  ],
  [
    24,
    172
  ],
  [
    25,
    174
  ],
  [
    26,
    175
  ],
  [
    27,
    174
  ],
  [
    28,
    175
  ],
  [
    29,
    174
  ],
  [
    31,
    175
  ],
  [
    30,
    176
  ]
]);
var n38 = t([
  [
    32,
    180
  ],
  [
    33,
    179
  ],
  [
    34,
    180
  ],
  [
    35,
    179
  ],
  [
    36,
    177
  ],
  [
    37,
    182
  ],
  [
    24,
    171
  ],
  [
    25,
    173
  ],
  [
    26,
    174
  ],
  [
    27,
    173
  ],
  [
    28,
    174
  ],
  [
    29,
    173
  ],
  [
    31,
    174
  ],
  [
    30,
    175
  ]
]);
var n39 = t([
  [
    32,
    201
  ],
  [
    33,
    200
  ],
  [
    34,
    201
  ],
  [
    35,
    200
  ],
  [
    36,
    198
  ],
  [
    37,
    203
  ],
  [
    24,
    191
  ],
  [
    25,
    193
  ],
  [
    26,
    194
  ],
  [
    27,
    193
  ],
  [
    28,
    194
  ],
  [
    29,
    193
  ],
  [
    31,
    194
  ],
  [
    30,
    195
  ]
]);
var n40 = t([
  [
    32,
    201
  ],
  [
    33,
    200
  ],
  [
    34,
    201
  ],
  [
    35,
    200
  ],
  [
    36,
    198
  ],
  [
    37,
    203
  ],
  [
    24,
    193
  ],
  [
    25,
    195
  ],
  [
    26,
    196
  ],
  [
    27,
    195
  ],
  [
    28,
    196
  ],
  [
    29,
    195
  ],
  [
    31,
    196
  ],
  [
    30,
    197
  ]
]);
var n41 = t([
  [
    32,
    201
  ],
  [
    33,
    200
  ],
  [
    34,
    201
  ],
  [
    35,
    200
  ],
  [
    36,
    198
  ],
  [
    37,
    203
  ],
  [
    24,
    192
  ],
  [
    25,
    194
  ],
  [
    26,
    195
  ],
  [
    27,
    194
  ],
  [
    28,
    195
  ],
  [
    29,
    194
  ],
  [
    31,
    195
  ],
  [
    30,
    196
  ]
]);
var n42 = t([
  [
    32,
    223
  ],
  [
    33,
    222
  ],
  [
    34,
    223
  ],
  [
    35,
    222
  ],
  [
    36,
    220
  ],
  [
    37,
    225
  ],
  [
    24,
    213
  ],
  [
    25,
    215
  ],
  [
    26,
    216
  ],
  [
    27,
    215
  ],
  [
    28,
    216
  ],
  [
    29,
    215
  ],
  [
    31,
    216
  ],
  [
    30,
    217
  ]
]);
var n43 = t([
  [
    32,
    223
  ],
  [
    33,
    222
  ],
  [
    34,
    223
  ],
  [
    35,
    222
  ],
  [
    36,
    220
  ],
  [
    37,
    225
  ],
  [
    24,
    215
  ],
  [
    25,
    217
  ],
  [
    26,
    218
  ],
  [
    27,
    217
  ],
  [
    28,
    218
  ],
  [
    29,
    217
  ],
  [
    31,
    218
  ],
  [
    30,
    219
  ]
]);
var n44 = t([
  [
    32,
    223
  ],
  [
    33,
    222
  ],
  [
    34,
    223
  ],
  [
    35,
    222
  ],
  [
    36,
    220
  ],
  [
    37,
    225
  ],
  [
    24,
    214
  ],
  [
    25,
    216
  ],
  [
    26,
    217
  ],
  [
    27,
    216
  ],
  [
    28,
    217
  ],
  [
    29,
    216
  ],
  [
    31,
    217
  ],
  [
    30,
    218
  ]
]);
var n45 = t([
  [
    32,
    245
  ],
  [
    33,
    244
  ],
  [
    34,
    245
  ],
  [
    35,
    244
  ],
  [
    36,
    242
  ],
  [
    37,
    247
  ],
  [
    24,
    235
  ],
  [
    25,
    237
  ],
  [
    26,
    238
  ],
  [
    27,
    237
  ],
  [
    28,
    238
  ],
  [
    29,
    237
  ],
  [
    31,
    238
  ],
  [
    30,
    239
  ]
]);
var n46 = t([
  [
    32,
    245
  ],
  [
    33,
    244
  ],
  [
    34,
    245
  ],
  [
    35,
    244
  ],
  [
    36,
    242
  ],
  [
    37,
    247
  ],
  [
    24,
    237
  ],
  [
    25,
    239
  ],
  [
    26,
    240
  ],
  [
    27,
    239
  ],
  [
    28,
    240
  ],
  [
    29,
    239
  ],
  [
    31,
    240
  ],
  [
    30,
    241
  ]
]);
var n47 = t([
  [
    32,
    245
  ],
  [
    33,
    244
  ],
  [
    34,
    245
  ],
  [
    35,
    244
  ],
  [
    36,
    242
  ],
  [
    37,
    247
  ],
  [
    24,
    236
  ],
  [
    25,
    238
  ],
  [
    26,
    239
  ],
  [
    27,
    238
  ],
  [
    28,
    239
  ],
  [
    29,
    238
  ],
  [
    31,
    239
  ],
  [
    30,
    240
  ]
]);
var n48 = t([
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    24,
    8
  ],
  [
    25,
    10
  ],
  [
    26,
    11
  ],
  [
    27,
    10
  ],
  [
    28,
    11
  ],
  [
    29,
    12
  ],
  [
    31,
    11
  ],
  [
    30,
    10
  ]
]);
var n49 = t([
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    24,
    10
  ],
  [
    25,
    12
  ],
  [
    26,
    13
  ],
  [
    27,
    12
  ],
  [
    28,
    13
  ],
  [
    29,
    14
  ],
  [
    31,
    13
  ],
  [
    30,
    12
  ]
]);
var n50 = t([
  [
    32,
    18
  ],
  [
    33,
    17
  ],
  [
    34,
    18
  ],
  [
    35,
    17
  ],
  [
    36,
    15
  ],
  [
    37,
    20
  ],
  [
    24,
    9
  ],
  [
    25,
    11
  ],
  [
    26,
    12
  ],
  [
    27,
    11
  ],
  [
    28,
    12
  ],
  [
    29,
    13
  ],
  [
    31,
    12
  ],
  [
    30,
    11
  ]
]);
var n51 = t([
  [
    32,
    266
  ],
  [
    33,
    265
  ],
  [
    34,
    266
  ],
  [
    35,
    265
  ],
  [
    36,
    177
  ],
  [
    37,
    268
  ],
  [
    24,
    257
  ],
  [
    25,
    259
  ],
  [
    26,
    260
  ],
  [
    27,
    259
  ],
  [
    28,
    260
  ],
  [
    29,
    261
  ],
  [
    31,
    260
  ],
  [
    30,
    259
  ]
]);
var n52 = t([
  [
    32,
    266
  ],
  [
    33,
    265
  ],
  [
    34,
    266
  ],
  [
    35,
    265
  ],
  [
    36,
    177
  ],
  [
    37,
    268
  ],
  [
    24,
    259
  ],
  [
    25,
    261
  ],
  [
    26,
    262
  ],
  [
    27,
    261
  ],
  [
    28,
    262
  ],
  [
    29,
    263
  ],
  [
    31,
    262
  ],
  [
    30,
    261
  ]
]);
var n53 = t([
  [
    32,
    266
  ],
  [
    33,
    265
  ],
  [
    34,
    266
  ],
  [
    35,
    265
  ],
  [
    36,
    177
  ],
  [
    37,
    268
  ],
  [
    24,
    258
  ],
  [
    25,
    260
  ],
  [
    26,
    261
  ],
  [
    27,
    260
  ],
  [
    28,
    261
  ],
  [
    29,
    262
  ],
  [
    31,
    261
  ],
  [
    30,
    260
  ]
]);
var n54 = t([
  [
    32,
    287
  ],
  [
    33,
    286
  ],
  [
    34,
    287
  ],
  [
    35,
    286
  ],
  [
    36,
    198
  ],
  [
    37,
    289
  ],
  [
    24,
    278
  ],
  [
    25,
    280
  ],
  [
    26,
    281
  ],
  [
    27,
    280
  ],
  [
    28,
    281
  ],
  [
    29,
    282
  ],
  [
    31,
    281
  ],
  [
    30,
    280
  ]
]);
var n55 = t([
  [
    32,
    287
  ],
  [
    33,
    286
  ],
  [
    34,
    287
  ],
  [
    35,
    286
  ],
  [
    36,
    198
  ],
  [
    37,
    289
  ],
  [
    24,
    280
  ],
  [
    25,
    282
  ],
  [
    26,
    283
  ],
  [
    27,
    282
  ],
  [
    28,
    283
  ],
  [
    29,
    284
  ],
  [
    31,
    283
  ],
  [
    30,
    282
  ]
]);
var n56 = t([
  [
    32,
    287
  ],
  [
    33,
    286
  ],
  [
    34,
    287
  ],
  [
    35,
    286
  ],
  [
    36,
    198
  ],
  [
    37,
    289
  ],
  [
    24,
    279
  ],
  [
    25,
    281
  ],
  [
    26,
    282
  ],
  [
    27,
    281
  ],
  [
    28,
    282
  ],
  [
    29,
    283
  ],
  [
    31,
    282
  ],
  [
    30,
    281
  ]
]);
var n57 = t([
  [
    32,
    308
  ],
  [
    33,
    307
  ],
  [
    34,
    308
  ],
  [
    35,
    307
  ],
  [
    36,
    220
  ],
  [
    37,
    310
  ],
  [
    24,
    299
  ],
  [
    25,
    301
  ],
  [
    26,
    302
  ],
  [
    27,
    301
  ],
  [
    28,
    302
  ],
  [
    29,
    303
  ],
  [
    31,
    302
  ],
  [
    30,
    301
  ]
]);
var n58 = t([
  [
    32,
    308
  ],
  [
    33,
    307
  ],
  [
    34,
    308
  ],
  [
    35,
    307
  ],
  [
    36,
    220
  ],
  [
    37,
    310
  ],
  [
    24,
    301
  ],
  [
    25,
    303
  ],
  [
    26,
    304
  ],
  [
    27,
    303
  ],
  [
    28,
    304
  ],
  [
    29,
    305
  ],
  [
    31,
    304
  ],
  [
    30,
    303
  ]
]);
var n59 = t([
  [
    32,
    308
  ],
  [
    33,
    307
  ],
  [
    34,
    308
  ],
  [
    35,
    307
  ],
  [
    36,
    220
  ],
  [
    37,
    310
  ],
  [
    24,
    300
  ],
  [
    25,
    302
  ],
  [
    26,
    303
  ],
  [
    27,
    302
  ],
  [
    28,
    303
  ],
  [
    29,
    304
  ],
  [
    31,
    303
  ],
  [
    30,
    302
  ]
]);
var n60 = t([
  [
    32,
    329
  ],
  [
    33,
    328
  ],
  [
    34,
    329
  ],
  [
    35,
    328
  ],
  [
    36,
    242
  ],
  [
    37,
    331
  ],
  [
    24,
    320
  ],
  [
    25,
    322
  ],
  [
    26,
    323
  ],
  [
    27,
    322
  ],
  [
    28,
    323
  ],
  [
    29,
    324
  ],
  [
    31,
    323
  ],
  [
    30,
    322
  ]
]);
var n61 = t([
  [
    32,
    329
  ],
  [
    33,
    328
  ],
  [
    34,
    329
  ],
  [
    35,
    328
  ],
  [
    36,
    242
  ],
  [
    37,
    331
  ],
  [
    24,
    322
  ],
  [
    25,
    324
  ],
  [
    26,
    325
  ],
  [
    27,
    324
  ],
  [
    28,
    325
  ],
  [
    29,
    326
  ],
  [
    31,
    325
  ],
  [
    30,
    324
  ]
]);
var n62 = t([
  [
    32,
    329
  ],
  [
    33,
    328
  ],
  [
    34,
    329
  ],
  [
    35,
    328
  ],
  [
    36,
    242
  ],
  [
    37,
    331
  ],
  [
    24,
    321
  ],
  [
    25,
    323
  ],
  [
    26,
    324
  ],
  [
    27,
    323
  ],
  [
    28,
    324
  ],
  [
    29,
    325
  ],
  [
    31,
    324
  ],
  [
    30,
    323
  ]
]);
var themes = {
  light: n1,
  dark: n2,
  light_accent: n3,
  light_white_accent: n3,
  light_SwitchThumb: n3,
  light_SliderTrack: n3,
  light_SliderThumb: n3,
  light_Tooltip: n3,
  light_ProgressIndicator: n3,
  light_white_SwitchThumb: n3,
  light_white_SliderTrack: n3,
  light_white_SliderThumb: n3,
  light_white_Tooltip: n3,
  light_white_ProgressIndicator: n3,
  dark_accent: n4,
  dark_black_accent: n4,
  dark_SwitchThumb: n4,
  dark_SliderTrack: n4,
  dark_SliderThumb: n4,
  dark_Tooltip: n4,
  dark_ProgressIndicator: n4,
  dark_black_SwitchThumb: n4,
  dark_black_SliderTrack: n4,
  dark_black_SliderThumb: n4,
  dark_black_Tooltip: n4,
  dark_black_ProgressIndicator: n4,
  light_black: n5,
  light_white: n6,
  light_blue: n7,
  light_red: n8,
  light_yellow: n9,
  light_green: n10,
  dark_black: n11,
  dark_white: n12,
  dark_blue: n13,
  dark_red: n14,
  dark_yellow: n15,
  dark_green: n16,
  light_black_accent: n17,
  light_black_SwitchThumb: n17,
  light_black_SliderTrack: n17,
  light_black_SliderThumb: n17,
  light_black_Tooltip: n17,
  light_black_ProgressIndicator: n17,
  light_blue_accent: n18,
  light_blue_SwitchThumb: n18,
  light_blue_SliderTrack: n18,
  light_blue_SliderThumb: n18,
  light_blue_Tooltip: n18,
  light_blue_ProgressIndicator: n18,
  light_red_accent: n19,
  light_red_SwitchThumb: n19,
  light_red_SliderTrack: n19,
  light_red_SliderThumb: n19,
  light_red_Tooltip: n19,
  light_red_ProgressIndicator: n19,
  light_yellow_accent: n20,
  light_yellow_SwitchThumb: n20,
  light_yellow_SliderTrack: n20,
  light_yellow_SliderThumb: n20,
  light_yellow_Tooltip: n20,
  light_yellow_ProgressIndicator: n20,
  light_green_accent: n21,
  light_green_SwitchThumb: n21,
  light_green_SliderTrack: n21,
  light_green_SliderThumb: n21,
  light_green_Tooltip: n21,
  light_green_ProgressIndicator: n21,
  dark_white_accent: n22,
  dark_white_SwitchThumb: n22,
  dark_white_SliderTrack: n22,
  dark_white_SliderThumb: n22,
  dark_white_Tooltip: n22,
  dark_white_ProgressIndicator: n22,
  dark_blue_accent: n23,
  dark_blue_SwitchThumb: n23,
  dark_blue_SliderTrack: n23,
  dark_blue_SliderThumb: n23,
  dark_blue_Tooltip: n23,
  dark_blue_ProgressIndicator: n23,
  dark_red_accent: n24,
  dark_red_SwitchThumb: n24,
  dark_red_SliderTrack: n24,
  dark_red_SliderThumb: n24,
  dark_red_Tooltip: n24,
  dark_red_ProgressIndicator: n24,
  dark_yellow_accent: n25,
  dark_yellow_SwitchThumb: n25,
  dark_yellow_SliderTrack: n25,
  dark_yellow_SliderThumb: n25,
  dark_yellow_Tooltip: n25,
  dark_yellow_ProgressIndicator: n25,
  dark_green_accent: n26,
  dark_green_SwitchThumb: n26,
  dark_green_SliderTrack: n26,
  dark_green_SliderThumb: n26,
  dark_green_Tooltip: n26,
  dark_green_ProgressIndicator: n26,
  light_ListItem: n27,
  light_SelectItem: n27,
  light_SelectTrigger: n27,
  light_Card: n27,
  light_Progress: n27,
  light_TooltipArrow: n27,
  light_Input: n27,
  light_TextArea: n27,
  light_white_ListItem: n27,
  light_white_SelectItem: n27,
  light_white_SelectTrigger: n27,
  light_white_Card: n27,
  light_white_Progress: n27,
  light_white_TooltipArrow: n27,
  light_white_Input: n27,
  light_white_TextArea: n27,
  light_Button: n28,
  light_white_Button: n28,
  light_Checkbox: n29,
  light_Switch: n29,
  light_TooltipContent: n29,
  light_RadioGroupItem: n29,
  light_SliderTrackActive: n29,
  light_white_Checkbox: n29,
  light_white_Switch: n29,
  light_white_TooltipContent: n29,
  light_white_RadioGroupItem: n29,
  light_white_SliderTrackActive: n29,
  dark_ListItem: n30,
  dark_SelectItem: n30,
  dark_SelectTrigger: n30,
  dark_Card: n30,
  dark_Progress: n30,
  dark_TooltipArrow: n30,
  dark_Input: n30,
  dark_TextArea: n30,
  dark_black_ListItem: n30,
  dark_black_SelectItem: n30,
  dark_black_SelectTrigger: n30,
  dark_black_Card: n30,
  dark_black_Progress: n30,
  dark_black_TooltipArrow: n30,
  dark_black_Input: n30,
  dark_black_TextArea: n30,
  dark_Button: n31,
  dark_black_Button: n31,
  dark_Checkbox: n32,
  dark_Switch: n32,
  dark_TooltipContent: n32,
  dark_RadioGroupItem: n32,
  dark_SliderTrackActive: n32,
  dark_black_Checkbox: n32,
  dark_black_Switch: n32,
  dark_black_TooltipContent: n32,
  dark_black_RadioGroupItem: n32,
  dark_black_SliderTrackActive: n32,
  light_black_ListItem: n33,
  light_black_SelectItem: n33,
  light_black_SelectTrigger: n33,
  light_black_Card: n33,
  light_black_Progress: n33,
  light_black_TooltipArrow: n33,
  light_black_Input: n33,
  light_black_TextArea: n33,
  light_black_Button: n34,
  light_black_Checkbox: n35,
  light_black_Switch: n35,
  light_black_TooltipContent: n35,
  light_black_RadioGroupItem: n35,
  light_black_SliderTrackActive: n35,
  light_blue_ListItem: n36,
  light_blue_SelectItem: n36,
  light_blue_SelectTrigger: n36,
  light_blue_Card: n36,
  light_blue_Progress: n36,
  light_blue_TooltipArrow: n36,
  light_blue_Input: n36,
  light_blue_TextArea: n36,
  light_blue_Button: n37,
  light_blue_Checkbox: n38,
  light_blue_Switch: n38,
  light_blue_TooltipContent: n38,
  light_blue_RadioGroupItem: n38,
  light_blue_SliderTrackActive: n38,
  light_red_ListItem: n39,
  light_red_SelectItem: n39,
  light_red_SelectTrigger: n39,
  light_red_Card: n39,
  light_red_Progress: n39,
  light_red_TooltipArrow: n39,
  light_red_Input: n39,
  light_red_TextArea: n39,
  light_red_Button: n40,
  light_red_Checkbox: n41,
  light_red_Switch: n41,
  light_red_TooltipContent: n41,
  light_red_RadioGroupItem: n41,
  light_red_SliderTrackActive: n41,
  light_yellow_ListItem: n42,
  light_yellow_SelectItem: n42,
  light_yellow_SelectTrigger: n42,
  light_yellow_Card: n42,
  light_yellow_Progress: n42,
  light_yellow_TooltipArrow: n42,
  light_yellow_Input: n42,
  light_yellow_TextArea: n42,
  light_yellow_Button: n43,
  light_yellow_Checkbox: n44,
  light_yellow_Switch: n44,
  light_yellow_TooltipContent: n44,
  light_yellow_RadioGroupItem: n44,
  light_yellow_SliderTrackActive: n44,
  light_green_ListItem: n45,
  light_green_SelectItem: n45,
  light_green_SelectTrigger: n45,
  light_green_Card: n45,
  light_green_Progress: n45,
  light_green_TooltipArrow: n45,
  light_green_Input: n45,
  light_green_TextArea: n45,
  light_green_Button: n46,
  light_green_Checkbox: n47,
  light_green_Switch: n47,
  light_green_TooltipContent: n47,
  light_green_RadioGroupItem: n47,
  light_green_SliderTrackActive: n47,
  dark_white_ListItem: n48,
  dark_white_SelectItem: n48,
  dark_white_SelectTrigger: n48,
  dark_white_Card: n48,
  dark_white_Progress: n48,
  dark_white_TooltipArrow: n48,
  dark_white_Input: n48,
  dark_white_TextArea: n48,
  dark_white_Button: n49,
  dark_white_Checkbox: n50,
  dark_white_Switch: n50,
  dark_white_TooltipContent: n50,
  dark_white_RadioGroupItem: n50,
  dark_white_SliderTrackActive: n50,
  dark_blue_ListItem: n51,
  dark_blue_SelectItem: n51,
  dark_blue_SelectTrigger: n51,
  dark_blue_Card: n51,
  dark_blue_Progress: n51,
  dark_blue_TooltipArrow: n51,
  dark_blue_Input: n51,
  dark_blue_TextArea: n51,
  dark_blue_Button: n52,
  dark_blue_Checkbox: n53,
  dark_blue_Switch: n53,
  dark_blue_TooltipContent: n53,
  dark_blue_RadioGroupItem: n53,
  dark_blue_SliderTrackActive: n53,
  dark_red_ListItem: n54,
  dark_red_SelectItem: n54,
  dark_red_SelectTrigger: n54,
  dark_red_Card: n54,
  dark_red_Progress: n54,
  dark_red_TooltipArrow: n54,
  dark_red_Input: n54,
  dark_red_TextArea: n54,
  dark_red_Button: n55,
  dark_red_Checkbox: n56,
  dark_red_Switch: n56,
  dark_red_TooltipContent: n56,
  dark_red_RadioGroupItem: n56,
  dark_red_SliderTrackActive: n56,
  dark_yellow_ListItem: n57,
  dark_yellow_SelectItem: n57,
  dark_yellow_SelectTrigger: n57,
  dark_yellow_Card: n57,
  dark_yellow_Progress: n57,
  dark_yellow_TooltipArrow: n57,
  dark_yellow_Input: n57,
  dark_yellow_TextArea: n57,
  dark_yellow_Button: n58,
  dark_yellow_Checkbox: n59,
  dark_yellow_Switch: n59,
  dark_yellow_TooltipContent: n59,
  dark_yellow_RadioGroupItem: n59,
  dark_yellow_SliderTrackActive: n59,
  dark_green_ListItem: n60,
  dark_green_SelectItem: n60,
  dark_green_SelectTrigger: n60,
  dark_green_Card: n60,
  dark_green_Progress: n60,
  dark_green_TooltipArrow: n60,
  dark_green_Input: n60,
  dark_green_TextArea: n60,
  dark_green_Button: n61,
  dark_green_Checkbox: n62,
  dark_green_Switch: n62,
  dark_green_TooltipContent: n62,
  dark_green_RadioGroupItem: n62,
  dark_green_SliderTrackActive: n62
};
export {
  colors,
  themes
};
//# sourceMappingURL=generated-v4.js.map
